import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/careful-doctor-consoling-rehab-patient_23-2148398252.jpg';

function DomesticViolenceServices() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Domestic Violence and Crisis Intervention Services" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Domestic Violence and Crisis Intervention Services</h4>
              <p>
                This sub-department is committed to providing resources and support to individuals and families experiencing domestic violence and other crises.<br />
                Services include confidential counseling, emergency shelters, and crisis hotlines to ensure safety and immediate assistance.<br /><br />
                By addressing these critical issues, we strive to create a supportive and secure environment for all members of our community.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Emergency Shelters</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Confidential Counseling Services</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Crisis Helplines</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to supporting individuals in crisis and providing them with the resources needed to rebuild their lives in safety and confidence.
              </p>
            </div>
            <div>
              <Link to="/department/family-services">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default DomesticViolenceServices;
